"use strict";

export function initInScope ($scope) {
    $scope.find('.js-modal-show').modal('show');
}